  const days = [
    "Søndag",
    "Mandag",
    "Tirsdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lørdag",
  ];
  const monthNames = [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december",
  ];

  const now = new Date();
  const future = new Date();
  future.setHours(now.getHours() + 11);

  let hours = 23 - future.getHours();
  let min = 60 - future.getMinutes();
  let sec = 60 - future.getSeconds();
  min = min < 10 ? "0" + min : min;
  sec = sec < 10 ? "0" + sec : sec;
  // document.querySelector(".timer").innerHTML = hours + " timer " + min + " min " + sec + " sek";4

  const deliveryDate = new Date(now);
  const currentDay = now.getDay();
  const currentHour = now.getHours();

  if (currentDay >= 1 && currentDay <= 4) {
    deliveryDate.setDate(deliveryDate.getDate() + (currentHour < 14 ? 1 : 2));
    if (deliveryDate.getDay() === 6) {
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    } else if (deliveryDate.getDay() === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
  } else if (currentDay === 5) {
    deliveryDate.setDate(deliveryDate.getDate() + 3);
  } else if (currentDay === 6) {
    deliveryDate.setDate(deliveryDate.getDate() + 2);
  } else {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  document.querySelector(".estimated-delivery span").innerHTML =
    days[deliveryDate.getDay()] + ", " + deliveryDate.getDate() + ". " + monthNames[deliveryDate.getMonth()];


let mainCartMain = document.querySelector('.cart__checkout-button');
let maincheckbox = document.querySelector('#maincartterms');
let mainerrorText = document.querySelector('#MA-text-red_main');
mainCartMain.addEventListener('click', (e)=>{
    if (!maincheckbox.checked) {
        e.preventDefault(); // Prevent form submission
        mainerrorText.classList.add('active');
    setTimeout(function(){
      mainerrorText.classList.remove('active');
    }, 3000);
    }
});